export const backgroundLight = "#dddddd";
export const backgroundDark = " #4d4d4d";
export const primaryColor = " #12324a";
export const secondaryColor = " #0f4b7a";
export const thirdColor = " #2f6188";
export const forthiColor = " #275172";
export const buttonDefault = " #0099bc";
export const LOGO_IMG = "images/logo.png";
export const HOME_VIDEO = "images/videobanner.mp4";